import React from "react";
import styles from "./Features.module.css";
import CheckIcon from '@mui/icons-material/Check';

function FeatureItem(props) {
    return (
        <div className={styles["feature-item"]}>
            <CheckIcon className={styles["check-icon"]} />
            <p>{props.feature}</p>
        </div>
    )
}

export default FeatureItem;